export default "__VITE_ASSET__CIwxQ1Z5__"